// extracted by css-extract-rspack-plugin
export default {"ViewSectionRoot":"LxV9X"};